import React from 'react';
import { networks } from '../mock';

const Networks = () => (
  <section id="networks" className="py-20 bg-muted/30 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-10">
        <div>
          <div className="section-label mb-4">Network Policy</div>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
            Polygon first, EVM-compatible later.
          </h2>
        </div>
        <p className="max-w-xl text-muted-foreground leading-relaxed">
          Tangibl3Net should not sell multi-chain deployment as the core product. The first priority is a disciplined issuer file and restricted certificate workflow on Polygon.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {networks.map((network) => (
          <div key={network.sym} className="rounded-2xl border border-border bg-card p-6">
            <div className="font-mono text-2xl font-bold text-foreground">{network.sym}</div>
            <div className="font-display font-semibold text-foreground mt-3">{network.name}</div>
            <div className="text-sm text-muted-foreground mt-1">{network.type}</div>
            {network.soon && <div className="mt-4 inline-flex rounded-md bg-muted px-2.5 py-1 font-mono text-[11px] text-muted-foreground">roadmap</div>}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Networks;
